import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { SettingsPaths } from "Settings/Routes/Routing";
import { useUserRoles } from "Settings/User/Api/Query/useUserRolesQuery";
import { Scrollbar } from "Shared/Components/Scroll/Scrollbar";
import { Add } from "@mui/icons-material";
import {
	Button,
	LinearProgress,
	List,
	ListItemButton,
	ListItemText,
	Stack,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router";

const userRolesResource = Resources.base.user.roles;

export const UserRolesList = () => {
	const { t } = useResource();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const paramsRole = searchParams.get("role");
	const decodedRole = paramsRole
		? decodeURIComponent(String(paramsRole))
		: undefined;

	const { data: roles, isLoading } = useUserRoles();

	const handleNavigateAddRole = () => {
		navigate(SettingsPaths.UsersRolesAdd.path());
	};

	const handleNavigateEditRole = (role: string) => {
		navigate({
			pathname: SettingsPaths.UsersRolesEdit.path(),
			search: `?role=${encodeURIComponent(role)}`,
		});
	};

	return (
		<Stack>
			<Button
				variant="contained"
				onClick={handleNavigateAddRole}
				sx={{ mb: 2 }}
				startIcon={<Add />}
			>
				{t(userRolesResource.addRole)}
			</Button>
			<List>
				<Scrollbar sx={{ maxHeight: 400 }}>
					{isLoading && (
						<LinearProgress
							sx={{
								height: "1px",
							}}
						/>
					)}
					{roles?.map((role) => (
						<ListItemButton
							key={role.name}
							selected={role.name === decodedRole}
							onClick={() => handleNavigateEditRole(role.name)}
						>
							<ListItemText>{role.name}</ListItemText>
						</ListItemButton>
					))}
				</Scrollbar>
			</List>
		</Stack>
	);
};
